// extracted by mini-css-extract-plugin
export var formContainer = "_j2-0";
export var message = "_j2-1";